import { InfoIcon, XCircleIcon, WarningIcon, CheckCircleIcon } from '@phosphor-icons/react/dist/ssr'

import { Alert as AlertUI, AlertDescription, AlertTitle } from '@/components/ui/alert'

export type AlertVariant = 'info' | 'error' | 'success' | 'warning'

export const Alert = ({ title, description, variant = 'info' }: { title?: string; description?: React.ReactNode | string; variant?: AlertVariant }) => {
  //We'll have to replace the icons with Phosphor icons once those are setup
  const icons = {
    info: <InfoIcon size={24} weight="fill" className="fill-grey-500" />,
    error: <XCircleIcon size={24} weight="fill" className="fill-error-700" />,
    success: <CheckCircleIcon size={24} weight="fill" className="fill-success-700" />,
    warning: <WarningIcon size={24} weight="fill" className="fill-warning-700" />,
  }

  return (
    <AlertUI className="shadow-[0px_6px_24px_0px_rgba(0,0,0,0.06)]" variant={variant}>
      {icons[variant]}
      {title && <AlertTitle>{title}</AlertTitle>}
      {description && <AlertDescription>{description}</AlertDescription>}
    </AlertUI>
  )
}
